(() => {
  const OFFER_DISCOUNTS = 'tiktok50,TIKTOKSHIP';
  const OFFER_PRICE = '$50 delivered';

  function offerCheckoutUrl(variantId) {
    const root = window.Shopify?.routes?.root || '/';
    return `${root}cart/${variantId}:1?discount=${encodeURIComponent(OFFER_DISCOUNTS)}`;
  }

  function initialiseOfferCards() {
    const offerSection = document.querySelector('[id^="FeaturedCollection-"]');

    if (!offerSection) return;

    offerSection.querySelectorAll('[data-product-block]').forEach((card) => {
      const variantInput = card.querySelector('input[name="id"]');

      if (!variantInput?.value) return;

      const checkoutUrl = offerCheckoutUrl(variantInput.value);

      card.querySelectorAll('a[data-grid-link]').forEach((link) => {
        link.href = checkoutUrl;
      });

      card.querySelectorAll('.product-grid-item__price').forEach((price) => {
        price.textContent = OFFER_PRICE;
      });

      const form = card.querySelector('form[action*="/cart/add"]');

      if (form) {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          window.location.assign(checkoutUrl);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseOfferCards, { once: true });
  } else {
    initialiseOfferCards();
  }
})();
